import React from 'react';
import { useTranslation } from 'react-i18next';
import CargomaticModal from '../../v2/modal';
const ShipmentClosedModal = (props) => {
    const { t } = useTranslation();
    const { onAccessorialClick, onCancelClick } = props;
    const renderBody = () => {
        return (React.createElement("div", null,
            React.createElement("h3", null, t('SHIPMENT_CLOSED_CONGRATS')),
            React.createElement("p", null, t('SHIPMENT_CLOSED_CONGRATS_MESSAGE')),
            React.createElement("div", { className: "mt-10 flex justify-around" },
                React.createElement("button", { onClick: onAccessorialClick, className: "button button-green" }, t('REQUEST_ACCESSORIAL_NOW')),
                React.createElement("button", { onClick: onCancelClick, className: "button" }, t('WILL_DO_LATER')))));
    };
    return (React.createElement(CargomaticModal, { style: { top: '35%' }, dialogClassName: "rounded-xl border-4 border-green-cm w-1/3", showHeader: false, show: props.show, onHide: () => { }, body: renderBody() }));
};
export default ShipmentClosedModal;
